import { Component, OnInit } from '@angular/core';
import { initFlowbite } from 'flowbite';
import { ToastrService } from 'ngx-toastr';
import { ApiResponseInterface } from 'src/app/interface/auth';
import { ProjectService } from '../../services/project.service';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.css']
})
export class AnalyticsComponent implements OnInit {

  public dataFound: boolean = false;
  clientSideExceptions!: { [key: string]: any };
  analyticData!: any;
  public analyticDataPaginations: any;

  filterOptions = [
    { value: 1, text: 'Today' },
    { value: 2, text: 'Yesterday' },
    { value: 7, text: 'Last 7 days' },
    { value: 15, text: 'Last 15 days' },
    { value: 30, text: 'Last 30 days' },
  ];

  filter: number = 7;

  // pagination related
  public values = '';
  public currentPage: number = 1;
  public itemsPerPage: number = 10;
  public totalItems: number;
  public totalPages: number;
  public apiUrl: string = "analytics/client/project";
  public startingIndex: number;
  public searchQuery: string = ''
  previous: boolean = false;
  next: boolean = false;

  constructor(
    private toastr: ToastrService,
    private projectService: ProjectService,

  ) { }

  ngOnInit(): void {
    initFlowbite();
    this.getAnalyticsData();
  }


  /**
   * Gets backend exceptions
   * @param {number} page
   * @param {number} limit
   */
  public getAnalyticsData() {
    this.projectService.getAnalytics(this.currentPage, this.itemsPerPage, this.searchQuery, this.filter).subscribe({
      next: (response: ApiResponseInterface) => {
        this.analyticData = response.data.docs;
        this.previous = response.data.hasPrePage;
        this.next = response.data.hasNextPage;
        this.totalPages = response.data.totalPages;
        this.totalItems = response.data.totalDocs;
        this.startingIndex = response.data.pagingCounter;
      },
      error: (error) => {
        this.toastr.error(error.error.message);
      }
    })
  }

  /**
   * Lists api logs component
   * @param list
   */
  list(list: any) {
    this.analyticData = list;
    // initFlowbite();

  }

  /**
 * Sets starting index
 * @param{number} index
 */
  setStartingIndex(index: number) {
    this.startingIndex = index;
  }

  /**
 * Determines whether page change on {Pagination}
 * @param{number} page
 */
  onPageChange(page: number): void {
    this.currentPage = page;
    this.getAnalyticsData()
  }

  handleSearch(event: any) {
    this.projectService.onSearch(event, (searchTerm: string) => {
      this.searchQuery = searchTerm.trim();
      this.getAnalyticsData()
    });
  }
  /**
 * Determines whether option selected on
 * @param selectedFilter
 */
  onOptionSelected(selectedFilter: any): void {
    this.filter = selectedFilter;
    this.currentPage = 1;
    this.getAnalyticsData()

  }


}
